// extracted by mini-css-extract-plugin
module.exports = {"rolesList":"Roles_rolesList__gThR5","roleCreate":"Roles_roleCreate__9c9wp"};